import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { FreeMode, Pagination, Navigation, Thumbs, Controller, EffectFade, Autoplay } from 'swiper/modules';


function newspage() {
    const featured_slider = document.querySelector('[data-target="featured_slider"]');
    if (!featured_slider) { return; }

    

    const featured_slider_pagination = featured_slider.querySelector('.swiper-pagination-vertical')
    const featured_slider_nav_next = featured_slider.querySelector('.swiper-button-next')

    const slider = new Swiper(featured_slider, {
        modules: [Pagination, Autoplay, Navigation,EffectFade],
        loop: true,
        draggable: true,
        allowTouchMove: true,
        spaceBetween: 20,
        slidesPerView: 1,
        effect: 'slide',
       
        pagination: {
            el: featured_slider_pagination,
            clickable: true,
        },
        navigation: {
            nextEl: featured_slider_nav_next,
          },

    });
    
    
}


export { newspage }; 